import { AutogenLayoutStateTaxTableList } from "./autogen/AutogenLayoutStateTaxTableList";
import { UrlUtil } from "@mcleod/core";

export class StateTaxTableList extends AutogenLayoutStateTaxTableList {
    async onLoad(): Promise<void> {
        const urlProp = UrlUtil.getPropsFromUrl(window.location.search);
        if (urlProp !== null) {
            if (urlProp.ids !== null && urlProp.ids !== undefined) {
                await this.mainDataSource.search({ ids: urlProp.ids }, this.layoutName);
            }
        } else {
            await this.mainDataSource.search(null, this.layoutName);
        }
    }
}
